import React, { useState } from 'react';
import { ChatLeftTextFill, TagsFill, StarFill, Diagram3Fill } from 'react-bootstrap-icons';
import { Badge } from 'react-bootstrap';

import SwipeableItem from 'components/SwipeableItem';

import { SwipeProvider } from 'hoc/SwipeContext';

import { getNotchIcon } from 'services/notches';

import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function ListOfNotches({
    items = [],
    settings,
    selectedDate,
    onClickHandler,
    onEditHandler,
    onDeleteHandler
}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const getTimeString = (createdAt) => {
        const dateObj = new Date(createdAt);

        const sameDay = dateObj.toDateString() === new Date(selectedDate).toDateString();
        const time = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const date = dateObj.toLocaleDateString("en-CA");

        return sameDay ? time : date + ' ' + time;
    }

    const modifiedItems = items.map(item => {
        let newItem = { ...item };

        if (item.created_at) {
            newItem.time = getTimeString(item.created_at);
        }

        return newItem;
    });

    return (
        <>
            {modifiedItems.length > 0 && (
                <SwipeProvider>
                    <ul className="list-group list-group-flush w-100 mb-1">
                        {modifiedItems.map((item, index) => (
                            <SwipeableItem
                                key={index}
                                id={item.uid || index}
                                onEdit={onEditHandler ? () => onEditHandler(item) : null}
                                onDelete={onDeleteHandler ? () => onDeleteHandler(item.uid) : null}
                                onClick={() => onClickHandler(item)}
                                className="position-relative overflow-hidden swipeable-wrapper"
                            >
                                <li
                                    className={`list-group-item w-100 ${!isMobile ? 'list-group-item-action' : ''}`}
                                    style={{
                                        cursor: "pointer",
                                        display: 'flex',
                                        alignItems: 'stretch',
                                    }}
                                >
                                    <div style={{
                                        width: '4px',
                                        minHeight: '100%',
                                        background: item.color,
                                        flexShrink: 0
                                    }} />

                                    <div style={{
                                        flex: 1,
                                        padding: '4px'
                                    }}>
                                        {/* Time */}
                                        {settings?.showTime?.checked && (
                                            <div className="mb-2 d-flex flex-wrap gap-2">
                                                <span >
                                                    {item.time}
                                                </span>
                                            </div>
                                        )}

                                        <div className="d-flex align-items-center">
                                            {getNotchIcon(
                                                item.type,
                                                {
                                                    color: item.color ?? null,
                                                    size: 18
                                                }
                                            )}

                                            <span className="flex-grow-1">{item.notch}</span>

                                            <div className="d-flex flex-wrap gap-2 justify-content-end">
                                                {item.note && item.note.trim() !== '' && (
                                                    <div className="d-flex align-items-center">
                                                        <ChatLeftTextFill size={16} />
                                                    </div>
                                                )}

                                                {item.values.length > 0 &&  (
                                                    <div className="d-flex align-items-center">
                                                        <Diagram3Fill size={16} />
                                                    </div>
                                                )}

                                                {item.tags.length > 0 && (
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <TagsFill size={16} />
                                                        {item.tags.length}
                                                    </div>
                                                )}

                                                {item.quick_access && (
                                                    <div className="d-flex align-items-center">
                                                        <StarFill size={16} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Tags */}
                                        {settings?.showTags?.checked && item.tags?.length > 0 && (
                                            <div className="mt-2 d-flex flex-wrap gap-2">
                                                {item.tags.map((tag) => (
                                                    <Badge key={tag.uid} bg="secondary" className="px-2 py-1 rounded-pill">
                                                        {tag.name}
                                                    </Badge>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                </li>
                            </SwipeableItem>
                        ))}
                    </ul>
                </SwipeProvider>
            )}
        </>
    );
};

export default ListOfNotches;
